import React, { useEffect, useState } from 'react'

import {
  UserMissionCardProps,
  WithUserMissionCardProps,
  TrophyProps,
} from './interface'

export function withUserMissionCard(Component: React.FC<UserMissionCardProps>) {
  function Hoc({ data }: WithUserMissionCardProps) {
    const [trophy, setTrophy] = useState<TrophyProps[]>([])

    useEffect(() => {
      const { currentLevel, completed, challengeLevels } = data

      setTrophy(
        challengeLevels
          .filter(prev => prev.isActive)
          .map((challenge, i) => ({
            iconUrl: challenge.iconUrl,
            active: i < currentLevel && completed > 0,
          }))
      )
    }, [data])

    const props = {
      data,
      trophy,
      showNextLevel: data.currentLevel < trophy.length,
    }

    return <Component {...props} />
  }

  return Hoc
}
